import Vue from "vue";
import { watch } from "../instance";

function useLocalStorage(key, defaultValue) {
  const storageValue = Vue.observable({ value: defaultValue });
  if (
    localStorage.getItem(key) &&
    JSON.parse(localStorage.getItem(key)).value
  ) {
    const temp = JSON.parse(localStorage.getItem(key)).value;
    if (temp) {
      storageValue.value = temp;
    }
  }
  watch(
    () => storageValue,
    () => {
      localStorage.setItem(key, JSON.stringify({ value: storageValue.value }));
    },
    {
      immediate: true,
      deep: true,
    }
  );
  function remove() {
    localStorage.removeItem(key);
  }
  return { value: storageValue, remove };
}

export default useLocalStorage;
